/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { from } from "rxjs";
@Component({
  selector: "app-quantity-view",
  templateUrl: "./quantity-view.component.html",
  styleUrls: ["./quantity-view.component.scss"],
})
export class QuantityViewComponent implements OnInit {
  @Input() title: string;
  @Input() quantity: number;
  constructor(private router: Router) {}
  navigate() {
    this.router.navigateByUrl("product/favourites");
  }
  ngOnInit() {}
}
